import { inject, Injectable, signal } from '@angular/core';
import { CommonHttpService } from '../../common-http.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, from, Observable, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IShippingAddressDTO } from '../../../models/IShippingAddressDTO ';

@Injectable({
  providedIn: 'root'
})
export class ShippingAddressService {

  private httpService = inject(CommonHttpService);
  private oidcSecurityService = inject(OidcSecurityService);
  private http = inject(HttpClient);


  shippingAddressInfoSignal = signal<IShippingAddressDTO | null>(null);

  constructor() { }

  public getShippingAddressInfo(): Observable<IShippingAddressDTO> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/shipping-address`;

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {

        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders();
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);

          return this.httpService.get<IShippingAddressDTO>(url, undefined, headers);
        } else {
          return throwError(() => new Error('User is not authenticated'));
        }
      }),
      tap(response => {
        this.shippingAddressInfoSignal.set(response);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg = typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    );
  }

  public putAccountInfo(data: IShippingAddressDTO): Observable<any> {


    const url = `${environment.apiUrl}/v3/accounts/my-account/shipping-address`;

    const bodyString = `shippingAddress=${JSON.stringify(data)}`;

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          });
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);
          return this.http.put<string>(url, bodyString, {
            headers,
            responseType: 'text' as 'json'
          });
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      }),

    )
  }
}
